module.exports = __webpack_public_path__ + "img/indicate_icon_2.6d47526a.png";